export default __webpack_public_path__ + "static/media/car.fafa1c7d.png";